module.exports = __webpack_public_path__ + "media/images/story/typo/declarationNatural-79ea2f0fbdd308928bd74c519e2e8d57.svg";